<template>
  <div class="content-box">
  <div class="company-page">
    <!-- 顶部标题栏 -->
    <div class="header-bar">
      安道亿联 • 欧亚专线领航者 | 一站式门到门跨境运输服务
    </div>

    <!-- 主体内容区 -->
    <div class="main-content">
      <!-- 公司介绍 + 城市图片 行 -->
      <div class="intro-row">
        <div class="intro-text">
          <h3>公司介绍</h3>
          <p>
              安道亿联（重庆）供应链管理有限公司（简称“安道亿联”）自2018年成立以来，依托总公司海关总署TIR监管系统先发优势和覆盖全球50,000+企业的生态网络，构建起"TIR跨境运输+数字供应链"双轮驱动的战略布局，致力于打造专业TIR跨境运输服务平台。
          </p>
          <p>
            平台通过覆盖“一带一路”沿线77个《TIR公约》国家的高效网络，为超5万家企业提供跨境运输、双清包税、口岸仓配及数字化工具的全链路服务。
          </p>
        </div>
        <div class="intro-image">
          <img src="@/assets/img/chongqing-bridge.png" alt="重庆城市风光" />
        </div>
      </div>

      <!-- 数据卡片 + 二维码 + 联系方式 行 -->
      <div class="bottom-row">
        <div class="data-card">
          <div class="data-number">5万+</div>
          <div class="data-text">平台用户</div>
          <div class="data-english">User Registration</div>
        </div>

        <div class="qrcode-wrapper">
          <div class="qrcode-container">
            <img src="@/assets/img/qrCode1.png" alt="联系二维码" class="qrcode-img" />

          </div>
        </div>

        <div class="contact-info">
          <h4>联系我们</h4>
          <div class="contact-item">
            <div class="icon-wrapper phone-icon">
              <i class="el-icon-phone-outline"></i>
            </div>
            <span class="contact-text">17318410357</span>
          </div>
          <div class="contact-item">
            <div class="icon-wrapper email-icon">
              <i class="el-icon-message"></i>
            </div>
            <span class="contact-text">jiangxinni1@mastery.net.cn</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyPage'
}
</script>

<style scoped>
.content-box {
  background: url(../assets/img/b3.jpg) repeat center;
}
/* 页面整体 */
.company-page {
  max-width: 1200px;
  margin: 0 auto;
  font-family: "Microsoft YaHei", sans-serif;
  height: calc(100vh - 120px);
}

/* 顶部标题栏 */
.header-bar {
  
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 24px;
  margin-top: 24px;
}

/* 主体内容 */
.main-content {
  padding: 0 24px;
}

/* 介绍行布局 */
.intro-row {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.intro-text {
  flex: 1;
  line-height: 1.8;
  color: #333;
}

.intro-text h3 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  color: #333;
}

.intro-text p {
  margin-bottom: 16px;
  text-indent: 2em;
}

.intro-image {
  flex: 1;
}

.intro-image img {
  width: 100%;
  height: auto;
  border-radius: 4px;
  object-fit: cover;
}

/* 底部行布局 */
.bottom-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

/* 数据卡片 */
.data-card {
  width: 30%;
  background-color: #1677ff;
  color: #fff;
  padding: 40px 20px;
  text-align: center;
  border-radius: 4px;
}

.data-number {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 12px;
}

.data-text {
  font-size: 20px;
  margin-bottom: 8px;
}

.data-english {
  font-size: 20px;
  font-style: italic;
}

/* 二维码 */
.qrcode-wrapper {
  width: 25%;
  display: flex;
  justify-content: center;
}

.qrcode-container {
  position: relative;
  width: 200px;
  height: 200px;
  padding: 8px;
  background: #fff;
}

.qrcode-img {
  width: 100%;
  height: 100%;
  display: block;
}

.qrcode-center-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}

.qrcode-center-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 联系方式 */
.contact-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contact-info h4 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 16px;
  color: #333;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.phone-icon {
  background-color: #d9d9d9;
  color: #333;
}

.email-icon {
  background-color: #d9d9d9;
  color: #333;
}

.contact-text {
  font-size: 14px;
  color: #333;
  word-break: break-all;
}
</style>